import { Checkbox } from "primereact/checkbox";
import "./AcceptPolicy.css"
import {Button} from "primereact/button";
export const AcceptPolicy = ({acceptPolicyFlag, setAcceptPolicyFlag, handleSubmit}) => {

    const publicOfferta = "Публічна оферта"
    const regulations = "Положення про обробку і захист персональних даних"

    return (
        <>
            <div className="flex align-items-center acceptPolicy" >
                <Checkbox inputId="accept"  onChange={(e) => setAcceptPolicyFlag(e.checked)} checked={acceptPolicyFlag} />
                <label htmlFor="accept" className="ml-2">Я приймаю <a href={`/${publicOfferta}.pdf`} target="_blank" rel="noopener noreferrer">Публічну оферту </a>
                та <a href={`/${regulations}.pdf`} target="_blank" rel="noopener noreferrer">Положення про обробку і захист персональних даних </a>  
                та даю згоду на обробку моїх персональних даних 
                </label>
            </div>
            <div style={{display:"flex", justifyContent: "end"}}>
                <Button label="Далі" onClick={handleSubmit} disabled={!acceptPolicyFlag} autoFocus className="continueBtn" />
            </div>
        </>
    )
}